import React from "react"
import { get } from "lodash"

import PanelGroup from "./panel-group"

const menu = {
  gettingstarted: [
    {
      name: "Getting Started",
      href: "/",
    },
    {
      name: "Background Information",
      href: "/protocols",
    },
  ],
  guides: [
    {
      name: "Register an Application",
      href: "/guides/register",
    },
    {
      name: "Authorization Overview",
      href: "/guides/authorizationoverview",
    },
    {
      name: "Socket.IO",
      href: "/guides/socketio",
    },
    {
      name: "Pagination",
      href: "/guides/pagination",
    },
    {
      name: "File System",
      href: "/guides/filesystem",
    },
    {
      name: "Pairing Code",
      href: "/guides/pairing_code",
    },
    {
      name: "Invitations",
      href: "/guides/invitations",
    },
    {
      name: "Authorization Types",
      href: "/guides/authorization_types",
    },
    {
      name: "Service Configurations",
      href: "/guides/service-configurations",
    },
    {
      name: "Limits",
      href: "/guides/limit",
    },
    {
      name: "Personal Meeting Room",
      href: "/guides/personal-meeting-room",
    },
    {
      name: "Find People",
      href: "/guides/find-people",
    },
    {
      name: "Unread Messages Count",
      href: "/guides/unread-messages-count",
    },
    {
      name: "IVR Languages Available",
      href: "/guides/ivr-languages-available",
    },
    {
      name: "Rich Input",
      href: "/guides/rich-input",
    },
    {
      name: "Raise Hands/Mute All",
      href: "/guides/raise-hands",
    },
  ],
  tutorials: [
    {
      name: "Authorizing Requests",
      href: "/tutorials/authorizingrequests",
    },
    {
      name: "User Search",
      href: "/tutorials/user_directory",
    },
    {
      name: "Manage a Space",
      href: "/tutorials/createanewspace",
    },
    {
      name: "Send and Receive Messages",
      href: "/tutorials/messages",
    },
    {
      name: "Media Session",
      href: "/tutorials/media_session",
    },
  ],
  other: [
    {
      name: "Provider File Type",
      href: "/other/providerfiletype",
    },
  ],
  api: [
    {
      name: "User API",
      href: "users",
      children: [
        {
          name: "GET /users/me",
          href: "/api/users/users_me",
        },
        {
          name: "GET /users/me/spaces",
          href: "/api/users/users_me_spaces",
        },
        {
          name: "GET /users/me/spaces/{spaceId}/hide",
          href: "/api/users/user_me_space_spaceid_hide__post",
        },
        {
          name: "GET /users/me/settings",
          href: "/api/users/users_me_settings",
        },
        {
          name: "POST /users/me/settings/{id}",
          href: "/api/users/users_me_settings_id",
        },
        {
          name: "GET /users/me/messages",
          href: "/api/users/users_me_messages",
        },
        {
          name: "GET /users/me/ideas",
          href: "/api/users/users_me_ideas",
        },
        {
          name: "GET /users/me/tasks",
          href: "/api/users/users_me_tasks",
        },
        {
          name: "GET /users/me/tasks/assigned",
          href: "/api/users/users_me_tasks_assigned",
        },
        {
          name: "POST /users/me/spaces/{spaceId}/preference",
          href: "/api/users/users_me_spaces_spaceid_preference",
        },
        {
          name: "GET /users/{userId}/colleagues",
          href: "/api/users/users_userid_colleagues",
        },
        {
          name: "POST /users/{userId}/colleaguesbulk",
          href: "/api/users/users_userid_colleaguesbulk",
        },
        {
          name: "GET /users/{userId}/people/withdm",
          href: "/api/users/users_userid_people_withdm",
        },
        {
          name: "GET /users/{userId}/statistics",
          href: "/api/users/users_userid_statistics",
        },
        {
          name: "GET /users/me/attachments/natives",
          href: "/api/users/users_me_attachments_natives",
        },
        {
          name: "DELETE /users/me/cm/subscriptions",
          href: "/api/users/users_me_cm_subscriptions__delete",
        },
        {
          name: "DELETE /users/me/cm/allsubscriptions",
          href: "/api/users/users_me_cm_allsubscriptions__delete",
        },
        {
          name: "POST /users/me/cm/subscriptions",
          href: "/api/users/users_me_cm_subscriptions__post",
        },
        {
          name: "POST /anonymous/auth",
          href: "/api/users/anonymous_auth",
        },
        {
          name: "POST /anonymous/me",
          href: "/api/users/anonymous_update",
        },
        {
          name: "GET /users/meetingroom/:email",
          href: "/api/users/users_meetingroom_email",
        },
        {
          name: "GET /users/{userId}/people (DEPRECATED)",
          href: "/api/users/users_userid_people",
        },
        {
          name: "POST /users/me/spaces/{spaceId}/markread",
          href: "/api/users/users_me_spaces_spaceid_markread",
        },
        {
          name: "GET /users/me/featuresrollout",
          href: "/api/users/users_me_featuresrollout",
        },
      ],
    },
    {
      name: "App API",
      href: "apps",
      children: [
        {
          name: "POST /api/apps/{app_id}/generate/pairingCode",
          href: "/api/apps/app_id_generate_pairingCodes",
        },
        {
          name: "POST  /api/apps/token/{tokentype}/{token}/invalidate",
          href: "/api/apps/token_tokentype_token_invalidate",
        },
        {
          name: "POST /api/apps/spaces/discover",
          href: "/api/apps/spaces_discover",
        },
        {
          name: "GET /api/apps/tokeninfo/{tokentype}/{token}",
          href: "/api/apps/tokeninfo_tokentype_token",
        },
      ],
    },
    {
      name: "Spaces API",
      href: "spaces",
      children: [
        {
          name: "GET /spaces/direct/{userType}/{userId}",
          href: "/api/spaces/spaces_direct_usertype_userid",
        },
        {
          name: "POST /spaces/invite",
          href: "/api/spaces/spaces_invite",
        },
        {
          name: "GET /spaces/invites/{inviteId}",
          href: "/api/spaces/spaces_invites_inviteid__get",
        },
        {
          name: "POST /spaces/invites/{inviteId}",
          href: "/api/spaces/spaces_invites_inviteid__post",
        },
        {
          name: "DELETE /spaces/invites/{inviteId}",
          href: "/api/spaces/spaces_invites_inviteid__delete",
        },
        {
          name: "GET /spaces/invites/{inviteId}/join",
          href: "/api/spaces/spaces_invites_inviteid_join",
        },
        {
          name: "GET /spaces/{spaceId}",
          href: "/api/spaces/spaces_spaceid__get",
        },
        {
          name: "POST /spaces/{spaceId}",
          href: "/api/spaces/spaces_spaceid__post",
        },
        {
          name: "DELETE /spaces/{spaceId}",
          href: "/api/spaces/spaces_spaceid__delete",
        },
        {
          name: "POST /spaces/{spaceId}/archive",
          href: "/api/spaces/spaces_spaceid_archive",
        },
        {
          name: "POST /spaces/{spaceId}/unarchive",
          href: "/api/spaces/spaces_spaceid_unarchive",
        },
        {
          name: "DELETE /spaces/{spaceId}/attendees/{attendeeType}/{attendee}",
          href:
            "/api/spaces/spaces_spaceid_attendees_attendeetype_attendee__delete",
        },
        {
          name: "POST /spaces/{spaceId}/attendees/{attendeeType}/{attendee}",
          href:
            "/api/spaces/spaces_spaceid_attendees_attendeetype_attendee__post",
        },
        {
          name: "POST /spaces/{spaceId}/chats",
          href: "/api/spaces/spaces_spaceid_chats__post",
        },
        {
          name: "GET /spaces/{spaceId}/ideas",
          href: "/api/spaces/spaces_spaceid_ideas__get",
        },
        {
          name: "POST /spaces/{spaceId}/ideas",
          href: "/api/spaces/spaces_spaceid_ideas__post",
        },
        {
          name: "POST /spaces/{spaceId}/invite",
          href: "/api/spaces/spaces_spaceid_invite",
        },
        {
          name: "GET /spaces/{spaceId}/join",
          href: "/api/spaces/spaces_spaceid_join",
        },
        {
          name: "GET /spaces/{spaceId}/members",
          href: "/api/spaces/spaces_spaceid_members",
        },
        {
          name: "GET /spaces/{spaceId}/messages/byref",
          href: "/api/spaces/spaces_spaceid_messages_byref",
        },
        {
          name: "GET /spaces/{spaceId}/messages/query",
          href: "/api/spaces/spaces_spaceid_messages_query",
        },
        {
          name: "GET /spaces/{spaceId}/tasks",
          href: "/api/spaces/spaces_spaceid_tasks__get",
        },
        {
          name: "POST /spaces/{spaceId}/tasks",
          href: "/api/spaces/spaces_spaceid_tasks__post",
        },
        {
          name: "GET /confnumbers",
          href: "/api/spaces/confnumbers",
        },
        {
          name: "GET /ams/mediaserver",
          href: "/api/spaces/ams_mediaserver",
        },
        {
          name: "GET /mediasessions/mpaas/token/{spaceId}",
          href: "/api/spaces/mediasessions_mpaas_token_spaceid__get",
        },
        {
          name: "POST /mediasessions/mpaas/{spaceId}/streams/states",
          href:
            "/api/spaces/mediasessions_mpaas_update_endpoint_sessions_streams_states_post",
        },
        {
          name: "POST /mediasessions/mpaas/{spaceId}/streams/remove",
          href:
            "/api/spaces/mediasessions_mpaas_update_endpoint_sessions_streams_remove_post",
        },
        {
          name: "GET /activitiesrecord/spaces (DEPRECATED)",
          href: "/api/spaces/activitiesrecord_spaces",
        },
        {
          name: "POST /spaces/ (DEPRECTATED)",
          href: "/api/spaces/spaces__post",
        },
        {
          name: "GET /spaces/{spaceId}/activemeeting",
          href: "/api/spaces/spaces_activemeeting__get",
        },
      ],
    },
    {
      name: "Files API",
      href: "files",
      children: [
        {
          name: "POST /files/getdownloadurl",
          href: "/api/files/files_getdownloadurl",
        },
        {
          name: "POST /files/getprofileimageuploadurl",
          href: "/api/files/files_getprofileimageuploadurl",
        },
        {
          name: "POST /files/getuploadurl",
          href: "/api/files/files_getuploadurl",
        },
        {
          name: "GET /files/viewurls/{token}",
          href: "/api/files/files_viewurls_token",
        },
      ],
    },
    {
      name: "Messages API",
      href: "messages",
      children: [
        {
          name: "GET /messages/parselink",
          href: "/api/messages/messages_parselink",
        },
        {
          name: "GET /messages/{id}",
          href: "/api/messages/messages_id__get",
        },
        {
          name: "POST /messages/{id}",
          href: "/api/messages/messages_id__post",
        },
        {
          name: "DELETE /messages/{id}",
          href: "/api/messages/messages_id__delete",
        },
        {
          name: "POST /messages/deletemessages",
          href: "/api/messages/messages_deletemessages",
        },
        {
          name: "GET /messages/{id}/file/{fileId}/viewerurl",
          href: "/api/messages/messages_id_files_fileid_viewerurl",
        },
        {
          name: "GET /ideas/{postId}/messages",
          href: "/api/messages/ideas_ideaid_messages",
        },
        {
          name: "GET /tasks/{taskId}/messages",
          href: "/api/messages/tasks_taskid_messages",
        },
        {
          name: "GET /activitiesrecord/messages (DEPRECATED)",
          href: "/api/messages/activitiesrecord_messages",
        },
      ],
    },
    {
      name: "Socket API",
      href: "socket",
      children: [
        {
          name: "SUBSCRIBE_CHANNEL",
          href: "/api/socket/subscribe_channel",
        },
        {
          name: "SUBSCRIBE_CHANNEL_FAILED",
          href: "/api/socket/subscribe_channel_failed",
        },
        {
          name: "UNSUBSCRIBE_CHANNEL",
          href: "/api/socket/unsubscribe_channel",
        },
        {
          name: "CHANNEL_SUBSCRIBED",
          href: "/api/socket/channel_subscribed",
        },
        {
          name: "CHANNEL_UNSUBSCRIBED",
          href: "/api/socket/channel_unsubscribed",
        },
        {
          name: "SEND_MESSAGE",
          href: "/api/socket/send_message",
        },
        {
          name: "MESSAGE_SENT",
          href: "/api/socket/message_sent",
        },
        {
          name: "SEND_PRESENCE_EVENT",
          href: "/api/socket/send_presence_event",
        },
        {
          name: "PRESENCE_EVENT_RESPONSE",
          href: "/api/socket/presence_event_response",
        },
        {
          name: "SEND_MEDIA_SESSION_EVENTS",
          href: "/api/socket/send_media_session_events",
        },
        {
          name: "MEDIA_SESSION_RESPONSE",
          href: "/api/socket/media_session_response",
        },
        {
          name: "APP_PAIRING_AUTHORIZED",
          href: "/api/socket/app_pairing_authorized",
        },
      ],
    },
  ],
}

export default props => {
  return (
    <div className="well well-sm nav-well" role="navigation">
      <PanelGroup
        target={1}
        title="Getting Started"
        links={menu.gettingstarted}
        open
      />
      <PanelGroup
        target={2}
        title="Guides"
        links={menu.guides}
        open={props.location.pathname.includes("/guides/")}
      />
      <PanelGroup
        target={3}
        title="Tutorials"
        links={menu.tutorials}
        open={props.location.pathname.includes("/tutorials/")}
      />
      <PanelGroup
        target={4}
        title="Other"
        links={menu.other}
        open={props.location.pathname.includes("/other/")}
      />
      <PanelGroup
        target={5}
        title="API Reference"
        links={menu.api}
        open
        apiOpen={props.location.pathname}
      />
    </div>
  )
}
